import { useEffect, useRef, useState } from 'react'
import renderImage from '../../../../source/importImg'
import styles from './ActionCreateNew.module.css'
import createStyle from '../ActionsCreate.module.css'

import WaveSurfer from 'wavesurfer.js'
import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions.js'
import TimelinePlugin from 'wavesurfer.js/dist/plugins/timeline.js'
import ZoomPlugin from 'wavesurfer.js/dist/plugins/zoom.js'
import { SINGLEACTIONSTATE } from '../defaultData'
import ActionCreateTableRow from './ActionCreateTableRow'
import { useIndexedDB } from 'react-indexed-db'

const timeline = TimelinePlugin.create({})
// const regions = RegionsPlugin.create({})
const zoomPlugin = ZoomPlugin.create({
    // the amount of zoom per wheel step, e.g. 0.5 means a 50% magnification per scroll
    scale: 0.5,
    // Optionally, specify the maximum pixels-per-second factor while zooming
    maxZoom: 100,
})

function ActionCreateNew({
    regions,
    allActions,
    addNewAction,
    deleteAction,
    handleSelectAction,
    selectedAction,
    updateMarkerById,
    handlePlayAction,
    servoDetailsPopupOpen,
    // isAudioEnable,
    tableBodyRef,
    waveSurferRef,
    display,
    setDisplay,
    setShowDeviceModal,
    actionNameChange,
    audioFile,
    setAudioFile,
    createActionState,
    setCreateActionState,
    sendReadServoBytes,
    portalPopupRef,
    isMotorTorqueEnable,
    setShowDeviceConnectModal,
}) {
    const connectedDevice =
        sessionStorage.getItem('connectedDevice') || 'Humanoid'
    const deviceVersion = sessionStorage.getItem('deviceVersion') || '1.0.1'

    const waveformDivRef = useRef(null)
    const { add, clear } = useIndexedDB('AudioFiles')
    // const waveSurferRef = useRef(null)

    // const [audioFile, setAudioFile] = useState(null)
    const [playAudio, setPlayAudio] = useState(false)
    // const [markers, setMarkers] = useState([])
    const fileInputRef = useRef(null)
    const [isDragging, setIsDragging] = useState(false)

    //click on the uload button
    const handelFileUploadBtn = () => {
        // if (!isAudioEnable) {
        //     return
        // }
        // console.log('HHHHHH')
        if (fileInputRef?.current) {
            fileInputRef.current.click()
        }
    }

    //handel the file read
    const fileRead = (file, fileInput) => {
        try {
            //check it is a mp3 file or not
            if (!file.name.toLowerCase().endsWith('.mp3')) {
                return
            }
            sessionStorage.setItem('isSave', JSON.stringify(false))
            setPlayAudio(false)

            const reader = new FileReader()
            reader.readAsDataURL(file)

            reader.onload = async () => {
                try {
                    const fileData = reader.result
                    setAudioFile(fileData)

                    const id = await add({
                        fileName: file.name,
                        fileData: fileData,
                    })

                    console.log('Audio file added with ID:', id)
                } catch (error) {
                    console.error(error)
                } finally {
                    console.log('File processing completed')
                    if (fileInput) fileInput.value = '' // Reset input after processing
                }
            }
        } catch (e) {
            console.error(e)
        }
    }

    //handel upload audio file
    const handelFileUpload = async (e) => {
        const fileInput = e.target // Store file input reference
        const file = fileInput.files[0]

        if (!file) return // Prevent errors if no file is selected
        fileRead(file, fileInput)
    }

    //drop the mp3 file in the ui box
    const handleDrop = (event) => {
        event.preventDefault()
        setIsDragging(false)

        const file = event.dataTransfer.files[0]
        fileRead(file)
    }

    const handleDragOver = (event) => {
        event.preventDefault()
        setIsDragging(true)
    }

    const handleDragLeave = () => {
        setIsDragging(false)
    }

    //handel click the pay pause button of the audio
    const handelPlayPause = () => {
        if (waveSurferRef?.current && display !== 'none' && audioFile) {
            waveSurferRef.current.playPause()
            setPlayAudio(!playAudio)
        }
    }

    // audioPlayRef.current = function palyAudio() {
    //     if (waveSurferRef?.current) {
    //         waveSurferRef.current.playPause()
    //         // setPlayAudio(!playAudio)
    //     }
    // }

    //handel click the restart button  of the audio
    const handelRestart = () => {
        if (waveSurferRef?.current) {
            waveSurferRef.current.setTime(0)
        }
    }

    // Handles clicking the forward or backward button of the audio player.
    // Moves the audio playback forward or backward by the specified skipTime in seconds.
    const handelForWardBackWard = (skipTime) => {
        if (waveSurferRef?.current) {
            waveSurferRef.current.skip(skipTime)
        }
    }

    // Initialize WaveSurfer
    useEffect(() => {
        setPlayAudio(false)
        if (waveformDivRef.current && audioFile) {
            waveSurferRef.current = WaveSurfer.create({
                container: waveformDivRef.current,
                waveColor: '#59b6d6',
                // progressColor: '#03a1d6',
                progressColor: '#00C462',
                backend: 'MediaElement',
                // height: '100',
                height: waveformDivRef.current.offsetHeight,
                url: audioFile,
                // mediaControls: true,
                // height: '50',
                // url: URL.createObjectURL(audioFile),
                // interact: false,
                plugins: [timeline, regions, zoomPlugin],
            })

            // waveSurferRef.current.load(URL.createObjectURL(audioFile))

            // Handle click to add markers
            waveSurferRef.current.on('click', (e) => {
                const time = waveSurferRef.current.getCurrentTime()

                // const { prevTimeInterval, nextTimeInterVal } =
                //     timeInterValCalculate(time.toFixed(3))
                // console.log(
                //     'JJJJJJJ11111222222',
                //     prevTimeInterval,
                //     nextTimeInterVal
                // )
                // if (
                //     prevTimeInterval < 0.1 ||
                //     prevTimeInterval > 5 ||
                //     nextTimeInterVal < 0.1 ||
                //     nextTimeInterVal > 5
                // ) {
                //     return
                // }
                let region1 = regions.addRegion({
                    start: time,
                    content: `${time.toFixed(3)}`,
                    color: 'rgba(255, 0, 0, 0.5)',
                })

                // sortMarker({ time: region1.start.toFixed(3), id: region1.id })
                addNewAction({
                    markerPositionTime: region1.start.toFixed(3),
                    id: region1.id,
                })
            })

            //handel the drag the marker update the time
            regions.on('region-updated', (region1, t) => {
                console.log('region-updated', region1, t)

                //handel the drag to prevent the marker put at end of the audio.
                const duration = (
                    waveSurferRef.current.getDuration() - 0.05
                ).toFixed(3)
                if (duration < region1.start) {
                    region1.setOptions({
                        end: duration,
                        start: duration,
                    })
                }
                region1.setOptions({
                    content: `${region1.start.toFixed(3)}`,
                })

                updateMarkerById(region1.id, region1.start.toFixed(3))
            })

            // waveSurferRef.current.on('decode', () => {
            //     markers.map((mark) => {
            //         regions.addRegion({
            //             start: mark.time,
            //             content: `${mark.time}`,
            //             color: 'rgba(255, 0, 0, 0.5)',
            //         })
            //     })
            // })

            /** When the audio is both decoded and can play */
            waveSurferRef.current.on('ready', (duration) => {
                setCreateActionState((prev) => {
                    let newAllActions = prev.allActions.map((action) => {
                        let region1 = regions.addRegion({
                            start: action.markerPositionTime,
                            content: `${action.markerPositionTime}`,
                            color: 'rgba(255, 0, 0, 0.5)',
                        })

                        action.id = region1.id
                        return action
                    })

                    return { ...prev, allActions: newAllActions }
                })
            })

            //when finish the audio play change the play mode
            waveSurferRef.current.on('finish', () => {
                setPlayAudio(false)
            })

            // Cleanup
            return () => {
                waveSurferRef.current.destroy()
            }
        }
        if (!audioFile) {
            waveSurferRef.current = null
        }
    }, [audioFile])

    //delete the marker and corresponding action
    const deleteMarker = (event, actionNumber, id) => {
        // if (isAudioEnable) {
        const regionss = regions.getRegions()
        const deletedRegion = regionss.find((ele) => {
            if (ele.id === id) {
                return ele
            }
        })
        if (deletedRegion) {
            deletedRegion.remove()
            deleteAction(event, actionNumber)
        } else {
            console.warn(`Region with id ${id} not found.`)
            deleteAction(event, actionNumber)
        }
        // } else {
        //     deleteAction(event, actionNumber)
        // }
    }

    //delete the audio file from ui
    const handelDeleteAudio = async () => {
        await clear()
        setAudioFile(null)
        setPlayAudio(false)
    }

    //restart the audio file
    const handelRestartAudio = () => {
        if (waveSurferRef?.current) {
            waveSurferRef.current.setTime(0)
        }
    }

    //copy the same action details
    const handelCopyAction = async (actionNumber, id) => {
        try {
            let newCreateActionState = JSON.parse(
                JSON.stringify(createActionState)
            )
            let newAction = JSON.parse(
                JSON.stringify(newCreateActionState.allActions[actionNumber])
            )

            if (waveSurferRef.current) {
                let region1 = regions.addRegion({
                    start: newAction.markerPositionTime,
                    content: `${newAction.markerPositionTime}`,
                    color: 'rgba(255, 0, 0, 0.5)',
                })
                newAction.id = region1.id
            } else {
                newAction.id = Math.random().toString(16).slice(2, 6)
            }
            newCreateActionState.allActions.splice(actionNumber, 0, newAction)

            setCreateActionState(newCreateActionState)
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <div className={styles.mainDiv}>
            <div className={styles.mainUpper}>
                {/* ------------------------- Wave from of the audio --------------------------------------------- */}
                {/* {!isAudioEnable && (
                    <div className={styles.waveFromDiv}>
                        <div className={styles.audioDisable}></div>
                    </div>
                )} */}
                {/* {isAudioEnable && ( */}
                <div className={styles.waveFromDivParent}>
                    <div className={styles.waveFromDiv}>
                        {audioFile ? (
                            <div
                                style={{ height: '14vh' }}
                                className={styles.waveFromRefDiv}
                                ref={waveformDivRef}
                            ></div>
                        ) : (
                            <div
                                className={styles.waveFromEmptyDiv}
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                style={{
                                    borderColor: isDragging
                                        ? '#03a1d6'
                                        : 'gray',
                                }}
                            >
                                <p>Drag & Drop an MP3 file here</p>
                            </div>
                        )}
                    </div>

                    <div style={{ display: 'flex' }}>
                        <div
                            className={styles.audioControlBtnDiv}
                            style={{
                                marginLeft: '2vw',
                            }}
                        >
                            <img
                                onClick={handelFileUploadBtn}
                                className={`${styles.btnStyle} ${styles.uploadBtn} ${createStyle.uploadBtn1}`}
                                src={renderImage('uploadBtn')}
                                alt="upload Button"
                                width="60vw"
                            />
                            <p
                                className={`${createStyle.tooltip} ${createStyle.uploadBtnTooltip}`}
                                style={{
                                    position: 'absolute',
                                    left: '50%',
                                    top: '-50%',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            >
                                Upload
                            </p>
                            <input
                                style={{ display: 'none' }}
                                type="file"
                                accept="audio/mp3"
                                ref={fileInputRef}
                                onChange={handelFileUpload}
                            />
                        </div>

                        <div
                            className={styles.audioControlBtnDiv}
                            style={{
                                marginLeft: '1vw',
                            }}
                        >
                            <img
                                style={audioFile ? {} : { cursor: 'default' }}
                                onClick={handelPlayPause}
                                className={`${styles.btnStyle} ${styles.playPauseBtn} ${createStyle.audioPlayBtn}`}
                                src={renderImage(
                                    playAudio ? 'pauseBtn' : 'playBtn'
                                )}
                                alt="Play Button"
                                width="30vw"
                            />
                            <p
                                className={`${createStyle.tooltip} ${createStyle.audioPlayBtnTooltip}`}
                                style={{
                                    position: 'absolute',
                                    left: '50%',
                                    top: '-50%',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            >
                                Play/Pause
                            </p>
                        </div>

                        <div
                            className={styles.audioControlBtnDiv}
                            style={{
                                marginLeft: '1vw',
                            }}
                        >
                            <img
                                // width="25vw"
                                className={`${styles.btnStyle} ${styles.playPauseBtn} ${createStyle.audioDeleteBtn}`}
                                src={renderImage('deleteBtn')}
                                alt="delete button"
                                onClick={(event) => {
                                    handelDeleteAudio()
                                }}
                                style={audioFile ? {} : { cursor: 'default' }}
                            />
                            <p
                                className={`${createStyle.tooltip} ${createStyle.audioDeleteBtnTooltip}`}
                                style={{
                                    position: 'absolute',
                                    left: '50%',
                                    top: '-50%',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            >
                                Delete
                            </p>
                        </div>

                        <div
                            className={styles.audioControlBtnDiv}
                            style={{
                                marginLeft: '1vw',
                            }}
                        >
                            <img
                                // width="25vw"
                                className={`${styles.btnStyle} ${styles.playPauseBtn} ${createStyle.audioDeleteBtn}`}
                                src={renderImage('restartBtn')}
                                alt="restart button"
                                onClick={(event) => {
                                    handelRestartAudio()
                                }}
                                style={audioFile ? {} : { cursor: 'default' }}
                            />
                            <p
                                className={`${createStyle.tooltip} ${createStyle.audioDeleteBtnTooltip}`}
                                style={{
                                    position: 'absolute',
                                    left: '50%',
                                    top: '-50%',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            >
                                Restart
                            </p>
                        </div>
                    </div>
                </div>
                {/* )} */}

                {/* ------------------ Control Panel Button -------------------- -------------------*/}
                {/* <div className={styles.controlDiv}>
                    <div className={styles.controlBtnDiv}>
                        <img
                            onClick={handelFileUploadBtn}
                            className={`${styles.btnStyle} ${
                                isAudioEnable ? '' : styles.disableBtnStyle
                            }`}
                            src={renderImage('uploadBtn')}
                            alt="upload Button"
                            width="30vw"
                        />
                        <input
                            style={{ display: 'none' }}
                            type="file"
                            accept="audio/mp3"
                            ref={fileInputRef}
                            onChange={handelFileUpload}
                        />
                    </div>
                    <div className={styles.controlBtnDiv}>
                        <img
                            onClick={handelPlayPause}
                            className={`${styles.btnStyle} ${
                                isAudioEnable ? '' : styles.disableBtnStyle
                            }`}
                            src={renderImage(
                                playAudio ? 'pauseBtn' : 'playBtn'
                            )}
                            alt="Play Button"
                            width="30vw"
                        />
                        <img
                            onClick={handelRestart}
                            className={`${styles.btnStyle} ${
                                isAudioEnable ? '' : styles.disableBtnStyle
                            }`}
                            src={renderImage('restartBtn')}
                            alt="Restart Button"
                            width="30vw"
                        />
                    </div>
                    <div className={styles.controlBtnDiv}>
                        <img
                            onClick={() => handelForWardBackWard(10)}
                            className={`${styles.btnStyle} ${
                                isAudioEnable ? '' : styles.disableBtnStyle
                            }`}
                            src={renderImage('forwardBtn')}
                            alt="Forward Button"
                            width="30vw"
                        />
                        <img
                            style={{ transform: 'rotate(180deg)' }}
                            onClick={() => handelForWardBackWard(-10)}
                            className={`${styles.btnStyle} ${
                                isAudioEnable ? '' : styles.disableBtnStyle
                            }`}
                            src={renderImage('forwardBtn')}
                            alt="Backrward Button"
                            width="30vw"
                        />
                    </div>
                </div> */}

                {/* ---------------------------- Device Image -------------------------------------------- */}
                <div className={styles.deviceImageDivParent}>
                    <div className={styles.deviceImageDiv}>
                        <img
                            onClick={setShowDeviceModal}
                            src={renderImage(
                                connectedDevice === 'Humanoid'
                                    ? 'humanoid'
                                    : 'hexapod'
                            )}
                            height="80%"
                            width="85%"
                        />
                        <p className={styles.imageText}>View Motors</p>
                    </div>
                </div>
            </div>

            {/* ----------------- table part of the ui ------------------------------------------ */}
            <div className={styles.mainLower}>
                {/* ----------------- table header of the ui ------------------------------------------ */}
                {/* <div className={styles.tableHeader}>
                    <div className={styles.tableHeaderLeft}>
                        {isAudioEnable && (
                            <p className={styles.tableHeaderMarks}>Marks</p>
                        )}
                        <p className={styles.tableHeaderActions}>Actions</p>
                    </div>
                    <div className={styles.tableHeaderRight}>
                        <p className={styles.tableHeaderMotor}>Motors</p>
                    </div>
                </div> */}

                {/* -----------------  table Body of the ui ------------------------------------------ */}
                <div ref={tableBodyRef} className={styles.tableBody}>
                    {allActions &&
                        allActions.map((element, ind) => {
                            return (
                                <div key={element.id}>
                                    <ActionCreateTableRow
                                        action={element}
                                        actionNumber={ind}
                                        handleSelectAction={handleSelectAction}
                                        selectedAction={selectedAction}
                                        deleteMarker={deleteMarker}
                                        handlePlayAction={handlePlayAction}
                                        servoDetailsPopupOpen={
                                            servoDetailsPopupOpen
                                        }
                                        // isAudioEnable={isAudioEnable}
                                        actionNameChange={actionNameChange}
                                        display={display}
                                        setDisplay={setDisplay}
                                        sendReadServoBytes={sendReadServoBytes}
                                        portalPopupRef={portalPopupRef}
                                        handelCopyAction={handelCopyAction}
                                        isMotorTorqueEnable={
                                            isMotorTorqueEnable
                                        }
                                        setShowDeviceConnectModal={
                                            setShowDeviceConnectModal
                                        }
                                    />
                                </div>
                            )
                        })}
                </div>
            </div>
        </div>
    )
}

export default ActionCreateNew
